var _circle, _path, _path2, _path3, _path4, _g, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgToDoIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 512,
    viewBox: "0 0 300 300",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 176.436,
    cy: 116,
    fill: "#efefd2",
    r: 90
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M258.666 45.883a4 4 0 01-2.828-6.828l6.779-6.777a4 4 0 115.656 5.656l-6.779 6.777a3.988 3.988 0 01-2.828 1.172zM242.85 61.701a4 4 0 01-2.828-6.828l6.779-6.779a4 4 0 115.656 5.656l-6.779 6.779a3.986 3.986 0 01-2.828 1.172zM248.877 45.133a3.988 3.988 0 01-2.828-1.172l-6.832-6.834a4 4 0 115.656-5.656l6.832 6.834a4 4 0 01-2.828 6.828zM265.445 61.701a3.988 3.988 0 01-2.828-1.172l-6.779-6.779a4 4 0 115.656-5.656l6.779 6.779a4 4 0 01-2.828 6.828z",
    fill: "#4c241d"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M60.292 54L34.555 79.714V270h144.127V54z",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M178.682 274H34.555a4 4 0 01-4-4V79.715c0-1.061.422-2.08 1.172-2.83L57.463 51.17A4.008 4.008 0 0160.291 50h118.391a4 4 0 014 4v216a4 4 0 01-4 4zm-140.127-8h136.127V58H61.947L38.555 81.373z",
    fill: "#4c241d"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M62.435 81.545V55.808L34.554 81.545z",
    fill: "#fff"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#4c241d"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M62.436 85.545H34.555a4.002 4.002 0 01-2.713-6.939L59.723 52.87a3.998 3.998 0 016.712 2.939v25.736c.001 2.209-1.79 4-3.999 4zm-17.651-8h13.65v-12.6zM90.436 146h-32a4 4 0 01-4-4v-32a4 4 0 014-4h32a4 4 0 014 4v32a4 4 0 01-4 4zm-28-8h24v-24h-24zM136.443 121.578h-27.252a4 4 0 010-8h27.252a4 4 0 010 8zM154.436 138h-44a4 4 0 010-8h44a4 4 0 010 8zM90.436 198h-32a4 4 0 01-4-4v-32a4 4 0 014-4h32a4 4 0 014 4v32a4 4 0 01-4 4zm-28-8h24v-24h-24zM136.443 173.578h-27.252a4 4 0 010-8h27.252a4 4 0 010 8zM154.436 190h-44a4 4 0 010-8h44a4 4 0 010 8zM90.436 254h-32a4 4 0 01-4-4v-32a4 4 0 014-4h32a4 4 0 014 4v32a4 4 0 01-4 4zm-28-8h24v-24h-24zM136.443 229.578h-27.252a4 4 0 010-8h27.252a4 4 0 010 8zM154.436 246h-44a4 4 0 010-8h44a4 4 0 010 8z"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M226.436 66c0-8.837-7.163-16-16-16s-16 7.163-16 16v4h32z",
    fill: "#ffded5"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M226.436 74h-32a4 4 0 01-4-4v-4c0-11.027 8.973-20 20-20s20 8.973 20 20v4a4 4 0 01-4 4zm-28-8h24c0-6.617-5.383-12-12-12s-12 5.383-12 12z",
    fill: "#4c241d"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M194.436 70h32v160h-32z",
    fill: "#ffce56"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M226.436 234h-32a4 4 0 01-4-4V70a4 4 0 014-4h32a4 4 0 014 4v160a4 4 0 01-4 4zm-28-8h24V74h-24z",
    fill: "#4c241d"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M214.436 146a4 4 0 01-4-4V70a4 4 0 018 0v72a4 4 0 01-4 4z",
    fill: "#4c241d"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M78.436 190a3.988 3.988 0 01-2.828-1.172l-8.002-8a4 4 0 115.656-5.656l5.174 5.172 17.172-17.172a4 4 0 115.656 5.656l-20 20A3.99 3.99 0 0178.436 190z",
    fill: "#a9ba5a"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M226.436 230h-32l6.399 16h19.201z",
    fill: "#e7d1c4"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M220.035 250h-19.199a4.005 4.005 0 01-3.715-2.514l-6.4-16c-.492-1.232-.342-2.629.402-3.729s1.984-1.758 3.312-1.758h32a4.002 4.002 0 013.714 5.487l-6.4 16a4.002 4.002 0 01-3.714 2.514zm-16.49-8h13.781l3.201-8h-20.184z",
    fill: "#4c241d"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M220.036 246h-19.201l9.601 24z",
    fill: "#6b4f5b"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M210.436 274a4.003 4.003 0 01-3.715-2.514l-9.6-24c-.492-1.232-.342-2.629.402-3.729s1.984-1.758 3.312-1.758h19.199a4.002 4.002 0 013.714 5.487l-9.6 24a3.997 3.997 0 01-3.712 2.514zm-3.692-24l3.691 9.229 3.691-9.229z",
    fill: "#4c241d"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgToDoIcon);
export default __webpack_public_path__ + "static/media/ToDoIcon.79fa79dc.svg";
export { ForwardRef as ReactComponent };